import {readAdminRuntimeStateFromStorage} from './readAdminRuntimeStateFromStorage'
import {resolveAdminRuntimeOverrides} from './resolveAdminRuntimeOverrides'

export function getRuntimeEnv(): typeof ENV {
  const state = readAdminRuntimeStateFromStorage()
  const overrides = resolveAdminRuntimeOverrides(state)
  return {
    ...ENV,
    ...overrides,
    AppBrandingName: ENV.AppBrandingName,
    FaviconPath: ENV.FaviconPath,
    Version: ENV.Version,
    ProjectName: ENV.ProjectName,
    EnvironmentPresets: ENV.EnvironmentPresets,
  }
}
